module.exports = __webpack_public_path__ + "static/img/jssm_zzfx_icon.png";